import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Box, Card, DialogContentText, Divider, Paper } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import OrderDetailsCardContent from "../OrdersQueue/OrderDetailsCardContent/OrderDetailsCardContent.tsx";

export default function ItemsDialog({ open, handleClose, orderId, items, queueManagementData, restaurntId }) {

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='customized-dialog-title'
      open={open}
      fullScreen
      PaperProps={{
        sx: {
          width: '80%',
          height: '90dvh',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '10px',
        },
      }}

    // Set maximum width of the dialog
    >
      <DialogTitle
        sx={{
          m: 0,
          pt: 3,
          pb: 1,
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#371b17',
        }}
        id='customized-dialog-title'
      >
        <ShoppingCartIcon fontSize='large' />
        <h3
          style={{
            margin: 0,
            fontSize: '1.8rem',
            fontWeight: 'bold',
            color: '#371b17',
          }}
        >
          Ordered Items
        </h3>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <hr />
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '10px 20px' }}>
          <p
            style={{
              textAlign: 'center',
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#333',
              marginBottom: '12px',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              background: '#f8f9fa',
              padding: '8px 0',
              borderRadius: '4px',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            #Order <span style={{ color: '#18b09f' }}>{queueManagementData[0]?.orderId?.slice(-6)}</span>
          </p>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {queueManagementData?.length === 0 ? (
              <h4>No order in this queue</h4>
            ) : (
              queueManagementData?.map((order, idx) => (
                <Card
                  key={idx}
                  className="CardForQueue mb-3"
                  sx={{
                    maxWidth: '345px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    background: '#fff',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '20px',
                    transition: 'transform 0.2s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.2)',
                    },
                    cursor: 'copy',
                  }}
                >
                  <div style={{ padding: '10px' }}>
                    <h4
                      style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#333',
                        marginBottom: '2px',
                      }}
                    >
                      Food Name: <span style={{ color: 'rgb(55, 27, 23)' }}>{order.itemName} X {order.itemQuantity}</span>
                    </h4>

                    <p style={{ margin: '0px 0px 0px 5px', padding: '0px 0px' }}>
                      {order?.addOns?.map((item, index) => (
                        <div key={index}>
                          <span>
                            {order?.addOns?.length === 0 ? "no add on" : ""}
                            AddOn :{" " + item.addOnName.toUpperCase()} X {item.addOnQuantity}
                          </span>

                          {item.options && item.options.length > 0 && (
                            <p style={{ margin: '0px 0px 0px 10px', padding: '0px 0px' }}>
                              <span style={{ fontWeight: 'lighter' }}>
                                {item?.options?.map((option, index) => (
                                  <div key={index}>
                                    <span>
                                      Option :{" " + option.optionName.toUpperCase()} X {option.optionQuantity}
                                    </span>

                                    {option.subOptions && option.subOptions.length > 0 && (
                                      <p style={{ margin: '0px 0px 0px 15px', padding: '0px 0px' }}>
                                        SubOption :
                                        <span style={{ fontWeight: 'lighter' }}>
                                          {option?.subOptions?.map((subOption, index) => (
                                            <span key={index}>
                                              {" " + subOption.subOptionName.toUpperCase()}
                                            </span>
                                          ))}
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                ))}
                              </span>
                            </p>
                          )}
                        </div>
                      ))}
                    </p>

                    {/* <h5
                      style={{
                        fontSize: '16px',
                        color: '#555',
                        marginBottom: '3px',
                      }}
                    >
                      Price: <span style={{ fontWeight: 'bold' }}>${order.basePrice}</span>
                    </h5> */}
                    <h6
                      style={{
                        fontSize: '14px',
                        color: '#666',
                        marginBottom: '0px',
                        marginTop: '8px',
                      }}
                    >
                      Kitchen Name: <span style={{ fontSize: '14px', fontWeight: 'normal' }}>{order.kitchenName}</span>
                    </h6>
                    <p
                      style={{
                        fontSize: '14px',
                        color: '#777',
                        marginBottom: '0px',
                        marginTop: '0',
                      }}
                    >
                      Order Time: <span>{new Date(order.orderDate).toLocaleString('en-US', {
                        weekday: 'short',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      })}</span>
                    </p>
                    <h5
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                      }}
                    >
                      Status: <span style={{ color: order.state === 'ready' ? 'coffee' : 'coffee' }}>{order.status}</span>
                    </h5>
                  </div>
                </Card>
              ))
            )}
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
